import {Controller} from "@hotwired/stimulus"
import moment from "moment/moment";
// Connects to data-controller="monitoring--time-period"

export default class extends Controller {
    static targets = ["from", "to"];

    connect() {
        this.fromPicker = flatpickr(this.fromTarget, { enableTime: true });
        this.toPicker = flatpickr(this.toTarget, { enableTime: true });
    }

    updateTime({detail: {from, to}}) {
        this.fromPicker.setDate(new Date(from * 1000), false);
        this.toPicker.setDate(new Date(to * 1000), false);
        this.dispatch("updateGraphs", {
            detail: {from, to},
            bubbles: true
        });

    }

    updateGraphs() {
        const from = Math.floor(new Date(this.fromTarget.value).getTime() / 1000)
        const to = Math.floor(new Date(this.toTarget.value).getTime() / 1000)

        this.dispatch("updateGraphs", {
            detail: {from, to},
            bubbles: true
        });
    }

    disconnect() {
        this.fromPicker.destroy()
        this.toPicker.destroy()
    }
}


